var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.309 10.071c0-.758-.616-1.367-1.388-1.367a1.367 1.367 0 100 2.734c.772 0 1.388-.608 1.388-1.367zm5.058 0c0-.758-.608-1.367-1.367-1.367-.752 0-1.36.608-1.36 1.367 0 .76.608 1.367 1.36 1.367.759 0 1.367-.608 1.367-1.367zm5.08 0c0-.758-.61-1.367-1.368-1.367-.772 0-1.38.608-1.38 1.367 0 .76.608 1.367 1.38 1.367.759 0 1.367-.608 1.367-1.367z",
    fill: "currentColor"
  })));
}

export default SvgMore;